import { render, staticRenderFns } from "./TvAppsEventGroupForm.vue?vue&type=template&id=65b09025&scoped=true&"
import script from "./TvAppsEventGroupForm.vue?vue&type=script&lang=js&"
export * from "./TvAppsEventGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./TvAppsEventGroupForm.vue?vue&type=style&index=0&id=65b09025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b09025",
  null
  
)

export default component.exports